/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

function Title({ children, className }) {
  return (
    <h1 className={`dtv-html5-c-detail-container__title ${className}`}>
      {children}
    </h1>
  );
}

Title.defaultProps = {
  className: '',
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default memo(Title);
